import cryptojs from 'crypto-js'

const generateSignature = (exportData: any) => {
  const private_key = process.env.REACT_APP_PRIVATE_KEY
  const inputString = JSON.stringify(exportData)
  if (!private_key) return false
  const hash = cryptojs.PBKDF2(inputString, private_key, {
    hasher: cryptojs.algo.SHA256,
    keySize: 16,
    iterations: 10000,
  })
  const hashHex = hash.toString(cryptojs.enc.Hex)
  return hashHex
}
export const examOnlineQuestionUploadApiIntegration = async (paperDetails: any, questionBankName: string) => {
  try {
    //creating the payload
    const payloadDetails = {
      questionbank: questionBankName,
      clientPublicKey: process.env.REACT_APP_PUBLIC_KEY,
      admin: 'varsha.g@centa.org',
      questionData: paperDetails,
    }
    //generating the header signature
    const signature = await generateSignature(payloadDetails)
    if (!signature) return false
    //sending the request
    const response = await fetch(process.env.REACT_APP_EXAM_ONLINE_API as string, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: signature,
      },
      body: JSON.stringify(payloadDetails),
    })
    if (!response.ok) {
      console.error('API failed', await response.text())
      return false
    }
    const result = await response.json()

    if (result?.successcount === paperDetails?.length) {
      return true
    }
    return false
  } catch (err) {
    console.log('error', err)
    return false
  }
}
